var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValoraciones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath20",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M 298.582,161.66 263.945,66.4961 c -1.312,-3.6016 -6.183,-3.8945 -7.754,-0.4609 l -28.5,62.1248 -61.769,-29.2733 c -3.41,-1.6172 -6.953,1.7383 -5.641,5.3403 l 34.789,95.586 c 0.637,1.753 16.641,-8.825 48.004,-31.731 37.645,-2.531 56.145,-4.672 55.508,-6.422 z m 104.176,37.731 34.637,-95.164 c 1.312,-3.602 -2.235,-6.9575 -5.645,-5.3403 l -61.766,29.2733 -28.5,-62.1248 c -1.574,-3.4336 -6.445,-3.1407 -7.754,0.4609 l -34.792,95.5859 c -0.637,1.754 18.417,3.938 57.171,6.547 30.461,22.262 46.012,32.516 46.649,30.762 z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath26",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M 0,0 H 600 V 600 H 0 Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath36",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd"
    },
    id: "path34",
    d: "m 476.754,289.027 c 0.57,1.973 1.137,3.946 1.641,5.946 0.695,1.136 1.382,2.625 2.035,4.59 6.031,18.089 19.57,25.195 19.57,40.117 0,16.566 -14.023,21.554 -19.57,39.8 -0.594,1.954 -1.211,3.477 -1.84,4.7 -0.492,1.988 -1.031,3.953 -1.586,5.914 0.051,1.347 -0.098,3.019 -0.527,5.101 -3.825,18.684 4.351,31.606 -3.114,44.528 -8.281,14.347 -22.922,11.652 -36.847,24.683 -1.575,1.473 -2.938,2.528 -4.145,3.274 -1.336,1.386 -2.687,2.758 -4.07,4.097 -0.625,1.223 -1.613,2.625 -3.067,4.262 -12.652,14.266 -12.035,29.543 -24.957,37.008 -14.347,8.281 -25.679,-1.371 -44.254,2.949 -2.019,0.469 -3.668,0.695 -5.05,0.758 -1.973,0.566 -3.946,1.133 -5.946,1.637 -1.136,0.699 -2.625,1.382 -4.586,2.039 -18.093,6.031 -25.199,19.57 -40.125,19.57 -16.562,0 -21.55,-14.027 -39.796,-19.57 -1.954,-0.594 -3.481,-1.211 -4.704,-1.844 -1.984,-0.492 -3.949,-1.027 -5.91,-1.582 -1.347,0.051 -3.019,-0.102 -5.101,-0.527 -18.684,-3.825 -31.606,4.351 -44.528,-3.114 -14.347,-8.281 -11.656,-22.922 -24.683,-36.847 -1.477,-1.578 -2.528,-2.938 -3.278,-4.145 -1.382,-1.336 -2.753,-2.691 -4.093,-4.07 -1.223,-0.625 -2.625,-1.617 -4.262,-3.071 -14.266,-12.648 -29.547,-12.031 -37.008,-24.957 -8.285,-14.347 1.371,-25.675 -2.949,-44.25 -0.469,-2.019 -0.699,-3.668 -0.758,-5.054 -0.57,-1.973 -1.137,-3.946 -1.637,-5.946 -0.699,-1.132 -1.386,-2.625 -2.039,-4.585 C 113.539,362.344 100,355.242 100,340.316 c 0,-16.562 14.027,-21.55 19.57,-39.796 0.594,-1.957 1.211,-3.481 1.844,-4.707 0.492,-1.985 1.027,-3.946 1.582,-5.907 -0.051,-1.351 0.102,-3.019 0.527,-5.105 3.825,-18.68 -4.351,-31.606 3.114,-44.528 8.281,-14.347 22.922,-11.652 36.847,-24.679 1.579,-1.477 2.938,-2.528 4.145,-3.278 1.34,-1.382 2.691,-2.753 4.07,-4.093 0.625,-1.223 1.617,-2.625 3.067,-4.266 12.652,-14.266 12.035,-29.543 24.961,-37.004 14.343,-8.285 25.675,1.371 44.25,-2.953 2.019,-0.469 3.668,-0.695 5.054,-0.754 1.973,-0.57 3.946,-1.137 5.942,-1.641 1.136,-0.699 2.625,-1.382 4.59,-2.039 18.093,-6.027 25.199,-19.57 40.121,-19.57 16.566,0 21.554,14.027 39.796,19.57 1.958,0.594 3.485,1.215 4.704,1.848 1.988,0.488 3.949,1.027 5.91,1.582 1.351,-0.051 3.019,0.102 5.101,0.527 18.684,3.825 31.606,-4.351 44.532,3.11 14.347,8.285 11.652,22.926 24.679,36.847 1.477,1.579 2.528,2.942 3.274,4.145 1.386,1.336 2.758,2.691 4.101,4.07 1.219,0.629 2.621,1.621 4.258,3.071 14.27,12.652 29.551,12.035 37.008,24.957 8.285,14.343 -1.371,25.679 2.949,44.25 0.469,2.019 0.699,3.672 0.758,5.054"
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath42",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M 0,0 H 600 V 600 H 0 Z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath54",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "m 339.113,385.301 c 3.664,5.012 10.84,6.203 16.024,2.66 5.187,-3.543 6.418,-10.481 2.754,-15.496 l -61.512,-84.129 c -4.02,-5.5 -12.137,-6.305 -17.231,-1.711 l -45.492,41.027 c -4.644,4.192 -4.898,11.223 -0.566,15.715 4.332,4.488 11.609,4.731 16.25,0.543 l 35.863,-32.344 z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath60",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M 0,0 H 600 V 600 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,80)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath20)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath26)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#204a77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 110,13.6211 h 377.672 v 236.379 H 110 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath36)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath42)",
    id: "g38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#e2c300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 50,89.9961 h 500 v 500.004 H 50 Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "none",
      stroke: "#004b7b",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 300,200.922 c 77.32,0 140,62.473 140,139.539 C 440,417.527 377.32,480 300,480 222.68,480 160,417.527 160,340.461 160,263.395 222.68,200.922 300,200.922 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g48"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath54)",
    id: "g50"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath60)",
    id: "g56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#004b7b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 180,233.637 H 410 V 440 H 180 Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValoraciones);
export default __webpack_public_path__ + "static/media/Valoraciones.65a48f994c97a149652aca79b53eb17e.svg";
export { ForwardRef as ReactComponent };